import { Box } from "@mui/material";
import { useNavigate } from "react-router";
import { useErrorBoundary } from "react-error-boundary";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import columns from "./columns";
import useClientList from "../hooks/useClientList";
import routes from "../../../routes";
import React from "react";

const style = {
  listContainer: { paddingTop: "8px", height: "77vh", width: "100%" },
  list: { "&:hover": { cursor: "pointer" } },
  actionButton: { opacity: 1 },
} as const;

function ClientList() {
  const { loading, clientList, error } = useClientList();
  const { showBoundary } = useErrorBoundary();

  React.useEffect(() => {
    if (error) {
      showBoundary(error);
    }
  }, [error, showBoundary]);

  const navigate = useNavigate();

  return (
    <>
      <Box data-testid="client-list-table-container" sx={style.listContainer}>
        <DataGrid
          data-testid="client-list-table"
          sx={style.list}
          rows={clientList}
          columns={columns}
          autoPageSize
          loading={loading}
          getRowHeight={() => "auto"}
          onRowClick={(rowData) =>
            navigate(routes.clients.view({ id: rowData.id.toString() }))
          }
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </Box>
    </>
  );
}

export default ClientList;
